import { Toaster } from '@/components/ui/sonner';
import { RouterContext } from '@/types/AppTypes';
import { TooltipProvider } from '@/components/ui/tooltip';
import NotFound from '@/components/pages/not-found/NotFound';
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootLayout,
  notFoundComponent: NotFound,
});

/**
 * Root layout for the TanStack Router.
 * Includes:
 * - Toaster for notifications
 * - View Transitions for page animations (native browser API)
 *
 * Note: Sentry browser tracing is handled automatically by
 * tanstackRouterBrowserTracingIntegration configured in main.tsx
 */
function RootLayout() {
  return (
    <div className="flex min-h-svh flex-col">
      <TooltipProvider>
        <main className="">
          <Outlet />
        </main>
      </TooltipProvider>
      <Toaster richColors expand={false} visibleToasts={1} position="top-center" />
    </div>
  );
}
